<div class="header-v2">

  <div class="icone-menu">

    <div class="hidden-xs" id="goHome-logo-interno">
      <img src="../../assets/img/icones_menu.svg" alt="Icone menu">
    </div>

    <div class="visible-xs" (click)="toggleMenuMobile()" id="goHome-logo-interno">
      <img src="../../assets/img/icones_menu.svg" alt="Icone menu">
    </div>

    <ul class="header-menu-list-v2 hidden-xs">
      <li><a (click)="navigateTo('home')">Home</a></li>
      <li><a (click)="navigateTo('produtos')">Produtos</a></li>
      <li><a (click)="navigateTo('vantagens')">Vantagens</a></li>
      <li><a (click)="navigateTo('contato')">Contato</a></li>
    </ul>

  </div>

  <div>
    <a [routerLink]="['/login']" class="btn btn-default-v2">Login Premiado</a>
  </div>


</div>
<ul class="header-menu-list-v2-hidden hidden">
  <li>
    <img src="../../../assets/img/PicPontos_cinza.svg" alt="Logo cinza">
  </li>

  <ul class="menu-list-nav">
    <li>
      <a (click)="navigateTo('home'); navPage()"><img src="../../../assets/img/public/bt_home.svg" alt="Botão Home"></a>
    </li>
    <li>
      <a (click)="navigateTo('produtos'); navPage()"><img src="../../../assets/img/public/bt_produtos.svg" alt="Botão Produtos"></a>
    </li>
    <li>
      <a (click)="navigateTo('vantagens'); navPage()"><img src="../../../assets/img/public/bt_vantangens.svg" alt="Botão Vantagens"></a>
    </li>
    <li>
      <a (click)="navigateTo('contato'); navPage()"><img src="../../../assets/img/public/bt_contato.svg" alt="Botão Contato"></a>
    </li>
  </ul>

  <li>
    <img (click)="toggleMenuMobile()" style="cursor: pointer;" src="../../../assets/img/icons/bt_sair_sem_label.svg"
      alt="botão Fechar menu mobile">
  </li>
</ul>


// WEBPACK FOOTER //
// ./src/app/public/header/header.component.html